import { motion } from 'framer-motion';

export const Spinner = ({ size = 'md', color = 'primary' }) => {
  const sizes = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12' };
  const colors = {
    primary: 'border-[#1a3a6e]',
    accent: 'border-[#e63946]',
    white: 'border-white'
  };

  return (
    <div className={`${sizes[size]} border-2 ${colors[color]} border-t-transparent rounded-full animate-spin`} />
  );
};

export const PageLoader = () => (
  <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
    <div className="text-center">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="mb-6"
      >
        <div className="text-3xl font-display font-bold">
          <span className="text-[#1a3a6e]">Sit</span>
          <span className="text-[#e63946]">Smart</span>
        </div>
      </motion.div>
      <Spinner size="lg" />
    </div>
  </div>
);

export const SkeletonCard = () => (
  <div className="bg-white overflow-hidden">
    <div className="skeleton h-64 w-full" />
    <div className="p-4 space-y-3">
      <div className="skeleton h-4 w-3/4 rounded" />
      <div className="skeleton h-3 w-1/2 rounded" />
      <div className="skeleton h-6 w-1/3 rounded" />
    </div>
  </div>
);

export default Spinner;
